/*
Copyright 2026 Element Creations Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { accountLoginAlias } from "../accountLogin";

/** Show/copy the application login, falling back to the Matrix localpart. */
export function localUsername(userId: string): string {
  return accountLoginAlias(userId) ?? userId.replace(/^@/, "").split(":", 1)[0];
}
